import React, { useState, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import { UserRegister, Label, SelectBox } from 'components';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import { apiPartnerUserRegister } from 'api/ZimssaAPI';
import { TServiceType } from 'api/ApiTypes';
import { useServiceStatus } from 'hooks';
import moment from 'moment';
import * as PAGE_URL from 'router/PageUrl';
import ZimssaConstant from 'commons/ZimssaConstant';
import { getYear, getMonth, getDays, validateInput, zeroPad, validatePhone, validateName, validationBirthDay, getUrlServiceType } from 'commons/ZimssaHelper';
import {
    PAGE_SERVICE_FAMILYMOVE,
    SELECT_DEFAULT_YEAR,
    SELECT_DEFAULT_MONTH,
    SELECT_DEFAULT_DAY,
    PLACEHOLDER_NAME,
    PLACEHOLDER_PHONE,
    LABEL_NAME,
    LABEL_PHONE,
    BUTTON_REGISTER,
    ALERT_NAME,
    ALERT_PHONE_PATTERN,
    TITLE_USER_REGISTER,
    PAGE_SERVICE_MOVECLEANING,
} from 'commons/ZimssaString';

function UserRegisterView(): React.ReactElement {
    const history = useHistory();
    const { partnerIdx } = useContext(PartnerAuthState);
    const { serviceIdx, serviceType, serviceDocStatus } = useServiceStatus();

    const [formState, setFormState] = useState<IUserRegisterForm>(defaultFormState);

    const [year, setYear] = useState<number>(0);
    const [month, setMonth] = useState<number>(0);
    const [day, setDay] = useState<number>(0);

    const onClickCallback = useCallback(
        (event: React.MouseEvent<HTMLDivElement, MouseEvent>, isChecked?: boolean, value?: string) => {
            if (isChecked && value) {
                setFormState({
                    ...formState,
                });
            } else {
                setFormState({
                    ...formState,
                });
            }
        },
        [formState]
    );

    const userRegisterProps = {
        title: TITLE_USER_REGISTER,
        profileImage: {
            value: formState.profileImage,
            inputName: 'profileIamge',
            isUpload: true,
            imgDir: ZimssaConstant.IMG_DIR.PARTNER_USER.PROFILE.replace('{{partnerIdx}}', `${partnerIdx}`),
            onChangeHandler: useCallback(
                (type: any, value: string) => {
                    setFormState({
                        ...formState,
                        profileImage: value,
                    });
                },
                [formState]
            ),
        },
        name: {
            inputProps: {
                inputName: 'name',
                placeholder: PLACEHOLDER_NAME,
                maxLength: 20,
                onChange: useCallback(
                    (e: React.ChangeEvent<HTMLInputElement>) => {
                        const { value } = e.target;
                        setFormState({
                            ...formState,
                            name: value,
                        });
                    },
                    [formState]
                ),
                isValid: validateName(formState.name),
            },
            label: LABEL_NAME,
            caption: validateName(formState.name) ? null : <Label contents={ALERT_NAME} color={'red_900'} fontStyle={'caption'} />,
        },
        phone: {
            inputProps: {
                inputName: 'phone',
                placeholder: PLACEHOLDER_PHONE,
                isValid: (() => {
                    if (validateInput(formState.phone.trim())) {
                        if (validatePhone(formState.phone)) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                })(),
            },
            label: LABEL_PHONE,
            caption: validateInput(formState.phone.trim()) && !validatePhone(formState.phone) ? <Label contents={ALERT_PHONE_PATTERN} color={'red_900'} fontStyle={'caption'} /> : null,
            onChangeHandler: useCallback(
                (type: any, value: string) => {
                    setFormState({
                        ...formState,
                        phone: value,
                    });
                },
                [formState]
            ),
        },
        birthDay: {
            children: [
                <SelectBox
                    key={1}
                    {...{
                        inputName: 'year',
                        children: [{ name: SELECT_DEFAULT_YEAR, value: 0 }, ...getYear(100)],
                        onChangeHandler: useCallback((type: any, value: string) => {
                            setYear(Number(value));
                        }, []),
                    }}
                />,
                <SelectBox
                    key={2}
                    {...{
                        inputName: 'month',
                        children: [{ name: SELECT_DEFAULT_MONTH, value: 0 }, ...getMonth()],
                        onChangeHandler: useCallback((type: any, value: string) => {
                            setMonth(Number(value));
                        }, []),
                    }}
                />,
                <SelectBox
                    key={3}
                    {...{
                        inputName: 'day',
                        children: year !== 0 && month !== 0 ? [{ name: SELECT_DEFAULT_DAY, value: 0 }, ...getDays(year, month)] : [{ name: SELECT_DEFAULT_DAY, value: 0 }],
                        onChangeHandler: useCallback((type: any, value: string) => {
                            setDay(Number(value));
                        }, []),
                    }}
                />,
            ],
        },

        onClickCancel: useCallback(
            (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                history.goBack();
            },
            [history]
        ),
        btnNext: {
            contents: BUTTON_REGISTER,
            isActive:
                validateName(formState.name) &&
                validateInput(formState.name.trim()) &&
                validatePhone(formState.phone) &&
                validationBirthDay(moment(new Date(`${year}-${zeroPad(month)}-${zeroPad(day)}`)).format('YYMMDD')),
            onClick: useCallback(
                (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                    apiPartnerUserRegister({
                        serviceIdx: serviceIdx ? Number(serviceIdx) : 0,
                        serviceType: serviceType as TServiceType,
                        profileImage: formState.profileImage,
                        name: formState.name,
                        phone: formState.phone,
                        birthday: moment(new Date(`${year}-${zeroPad(month)}-${zeroPad(day)}`)).format('YYMMDD')
                    }).then((response) => {
                        const { result, message } = response;
                        if (result === 'success') {
                            alert('기사님을 추가 하였습니다.');
                            if (serviceDocStatus === 'interview_approve') {
                                history.push(`${PAGE_URL.SERVICE_INTERVIEWAPPROVE.url}/${getUrlServiceType(serviceType)}/${serviceIdx}`);
                            } else if (serviceDocStatus === 'interview_nonapprove') {
                                history.push(`${PAGE_URL.SERVICE_INTERVIEWNOAPPROVE.url}/${getUrlServiceType(serviceType)}/${serviceIdx}`);
                            } else {
                                history.push(`${PAGE_URL.USER_LIST.url}/${getUrlServiceType(serviceType)}/${serviceIdx}`);
                            }
                        } else {
                            if (message) alert(message);
                        }
                    });
                },
                [day, formState.name, formState.phone, formState.profileImage, history, month, serviceDocStatus, serviceIdx, serviceType, year]
            ),
        },
    };
    return (
        <Template title={(() => {
          if (serviceType === 'familymove') {
              return PAGE_SERVICE_FAMILYMOVE;
          }

          if (serviceType === 'move_cleaning') {
              return PAGE_SERVICE_MOVECLEANING;
          }

          return '';
      })()}>
            <UserRegister {...userRegisterProps} />
        </Template>
    );
}

export default UserRegisterView;

const defaultFormState: IUserRegisterForm = {
    profileImage: '',
    name: '',
    phone: '',
};

interface IUserRegisterForm {
    profileImage: string;
    name: string;
    phone: string;
}
